import { memo } from "react";

// Matches an opening or closing HTML tag (e.g. <br>, <strong>, </em>).
const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*?>/i;

/**
 * Renders merchant-authored `type: "html"` setting values as inline HTML.
 *
 * Values without an HTML tag are rendered as an escaped text node so plain-text
 * content containing bare `<`, `>`, or `&` is not mangled by innerHTML parsing
 * (sc-26116 acceptance: no regression to plain-text content).
 *
 * Intended for inline/phrasing content only — it renders an inline <span> and is
 * nested inside <Text>/<Heading> primitives, so block-level markup (<p>, <div>,
 * <ul>) is out of contract.
 */
const HtmlContentBase = ({ html }: { html: string }) => {
  if (!HTML_TAG_PATTERN.test(html)) {
    return <>{html}</>;
  }

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export const HtmlContent = memo(HtmlContentBase);
